import { render, staticRenderFns } from "./DispatchDetail.vue?vue&type=template&id=ac60dfd6&"
import script from "./DispatchDetail.vue?vue&type=script&lang=ts&"
export * from "./DispatchDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports